import type { OrganizationData, OrganizationsList } from '@openx/types/organization.ts';

export type HierarchyItem = {
  id: string;
  name: string;
  depth: number;
};

export const buildOrganizationHierarchy = (
  organization: OrganizationData,
  parentOrganizationsData: OrganizationsList[]
): HierarchyItem[] => {
  const { path_to_root, name, id } = organization;

  const ancestors: HierarchyItem[] = path_to_root
    ? path_to_root.map((ancestorId, index) => ({
        id: ancestorId,
        name: parentOrganizationsData.find(org => org.id === ancestorId)?.name ?? ancestorId,
        depth: index,
      }))
    : [];

  // add the current organization to the hierarchy as the last item
  return [...ancestors, { id, name, depth: path_to_root ? path_to_root.length : 0 }];
};
